<template>
  <div class="merchant-info-setting">
    <div class="sectionItem">
      <div class="sectionItem_title">{{ $t('merchant.merchant_basic_info') }}</div>
      <div>
        <el-row class="sectionItem_name">
          <el-col :span="24" v-loading="uploadLoading" class="sectionItem_col" style="height: 90px">
            <div style="display: inline-block"><span class="sectionItem_col-label">{{ $t('merchant.merchant_logo') }}：</span></div>
            <div style="display: inline-block">
              <el-upload
                class="head-img-upload"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :file-list="fileList"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                :limit="1"
                :on-change="handleImageChange"
                :class="{'hideUploadFlag': isHideUpdate}">
                <i slot="default" class="el-icon-plus"/>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" style="width: 80px; height: 80px;">
                  <span class="el-upload-list__item-actions" >
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"/>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>
            <div style="display: inline-block" v-if="userInfo.merchant_basic_info.logo_img">
              <el-upload
                action="#"
                class="head-img-upload-btn"
                list-type="picture-card"
                :auto-upload="false"
                :show-file-list="false"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                :file-list="fileList"
                :on-change="handleImageChange">
                <i class="el-icon-edit update-head-img" />
              </el-upload>
            </div>
          </el-col>
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.merchant_name') }}：</span>{{ userInfo.merchant_name }}
          </el-col>
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.merchant_no') }}：</span>{{ userInfo.merchant_no }}
          </el-col>
        </el-row>
        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.merchant_type') }}：</span>
            {{ getMerchantTypeMap( userInfo.merchant_type) }}</el-col>
          <!-- <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.legal_person_name') }}：</span>
            {{ userInfo.merchant_basic_info.legal_person_name }}</el-col> -->
        </el-row>
        <!-- <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label"> {{ $t('merchant.contract_name') }}：</span>
            {{ userInfo.merchant_basic_info.contact_person_name }}</el-col>
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label"> {{ $t('merchant.contract_mobile') }}：</span>
            {{ userInfo.merchant_basic_info.contact_person_mobile }}</el-col>
        </el-row> -->
        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.notification_email') }}：</span>
            {{ userInfo.merchant_basic_info.notification_email }}</el-col>
        </el-row>
        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.notification_phone') }}：</span>
            {{ userInfo.merchant_basic_info.notification_phone }}</el-col>
        </el-row>
        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label">{{ $t('merchant.contract_effect_time') }}：</span>
            {{ userInfo.contract_validity_start }}   {{ userInfo.contract_validity_start? $t('merchant.to') : '-' }}   {{ userInfo.contract_validity_end }}</el-col>
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label"> {{ $t('merchant.merchant_status') }}：</span>
            {{ getMerchantStatusMap(userInfo.merchant_status) }}</el-col>
        </el-row>
<!--        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label"> {{ $t('merchant.settlement_bank') }}：</span>
            {{ userInfo.merchant_basic_info.settlement_bank }} </el-col>
        </el-row>
        <el-row class="sectionItem_name">
          <el-col :span="12" class="sectionItem_col">
            <span class="sectionItem_col-label"> {{ $t('merchant.settlement_bank_num') }}：</span>
            {{ userInfo.merchant_basic_info.settlement_bank_account_num }}</el-col>
        </el-row>-->
      </div>
    </div>

    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { merchantTypeMap, merchantStatusMap } from '@/utils/maps'
import { fetchMerchantInfo } from '@/api/merchant-manage/merchant-manage'
import { uploadImg } from '@/api/components/upload'
import { updateMchLogoImg } from '@/api/merchant-manage/merchant-manage'
import serviceConst from '@/const/serviceConst.json'

export default {
  name: 'MerchantInfoItem',
  data() {
    return {
      userInfo: {
        merchant_basic_info: {}
      },
      merchantUser: this.$store.getters.userInfo,
      uploadLoading: false,
      dialogImageVisible: false,
      dialogImageUrl: '',
      fileList: [],
      pic_path: ''
    }
  },
  computed: {
    // userInfo() {
    //   const { userInfo } = this.$store.state.user
    //   return userInfo
    // },
    getMerchantTypeMap() {
      return function(value) {
        return merchantTypeMap(value).label
      }
    },
    getMerchantStatusMap() {
      return function(value) {
        return merchantStatusMap(value).label
      }
    },
    isHideUpdate() {
      return this.fileList && this.fileList.length > 0
    },
  },
  watch: {
    '$store.getters.logoImgOssUrl': {
      handler: function () {
        this.getMerchantLogo()
      },
      deep: true
    }
  },
  created() {
    this.getMerchant()
    this.getMerchantLogo()

  },
  methods: {
    getMerchant() {
      fetchMerchantInfo().then(response => {
          const { data } = response
          if (!data) {
            return this.$message({ message: 'Verification failed, please Login again.', type: 'warning' })
          }
          this.userInfo = data.merchant

      })
    },
    getMerchantLogo() {
      let logoImgOssUrl = this.$store.getters.logoImgOssUrl
      if(logoImgOssUrl) {
        this.fileList = [{url: logoImgOssUrl}]
      } else {
        this.fileList = []
      }
    },
    handleImageChange(file, fileList) {

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('The size of the uploaded image cannot exceed 2MB!');
        this.getMerchantLogo()
        return;
      }

      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }

      this.fileList = []

      this.uploadLoading = true
      const formData = new FormData()
      formData.append('business', 'MERCHANT_INFO')
      formData.append('file', file.raw)
      uploadImg(formData).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.pic_path = res.data.path
          this.fileList = [file]
          this.updateMchLogo()
        }
      })
    },
    updateMchLogo() {
      let params = {
        logo_img: this.pic_path
      }
      updateMchLogoImg(params).then(res => {
        if(res.code === serviceConst.resCode.succ) {
          this.$message.success('Upload Logo Success')
        }
      }).finally(() => {
        this.$store.dispatch('user/getInfo').then(res => {})
        this.uploadLoading = false
      })

    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
  },


}
</script>

<style lang="scss">
  .merchant-info-setting {
    .head-img-upload .el-upload--picture-card {
      width: 80px;
      height: 80px;
      line-height: 88px;
      border-radius: 50%;
    }
    .head-img-upload .el-upload-list--picture-card .el-upload-list__item {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .head-img-upload-btn .el-upload--picture-card {
      width: 80px;
      height: 80px;
      border: 0;
    }
  }
</style>

<style lang="scss" scoped>
  .sectionItem{
    &_title{
      margin-bottom: 32px;
      font-size: 18px;
      font-weight: 500;  font-family: 'Inter-Medium';
      color: #3855F1;
    }
    &_name{
      margin-top: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #4B5567;
    }
    &_a{
      font-size: 12px;
      line-height: 17px;
      color: #3579FF;
      text-decoration: underline;
    }
    .sectionItem_col-label{
      color: #98A1B4;
      display: inline-block;
      width: 200px;
    }
  }

  .update-head-img {
    text-align: left;
    vertical-align: top;
    &:hover{
      color: #3855F1;
    }
  }

  @media screen and (max-width: 376px) {
  .sectionItem_name{
    margin: 0;
  }
  .sectionItem_col{
    width: 100%;
    margin-top: 10px;
  }
}

</style>
